import React, { useState,useEffect, useMemo } from "react";
import { Link } from "react-router-dom";
import Header from "../layouts/Header";
import Sidebar from "../layouts/Sidebar";
import "../_components/antd.css";

import { Table, Tooltip } from "antd";
//import Data from "../assets/jsons/customers";
import { useAuth } from "../context/AuthContext";
import { useHistory } from "react-router-dom";
import api from "../api/api"
import {
    onShowSizeChange,
    itemRender,
} from "../_components/paginationfunction";
import { useTranslation } from 'react-i18next';
import SuperUsersMobile from "./SuperUsersMobile";
import * as Icon from "react-feather";

const SuperUsers = () => {
        const {user} = useAuth();
        const { t } = useTranslation();
    const history = useHistory();
    const [activeTab, setActiveTab] = useState(user.type === "supplier" ? "vendor" : "agency");
        useEffect(()=>{
           
         
            if(!user.super){
              history.push("/dashboard")
            }
            fetchData(1, activeTab)
        },[activeTab])

        useEffect(()=>{
            if(!user.super){
              history.push("/dashboard")
            }
            fetchData()
        },[])
    
    const [loadingInvitation, setloadingInvitation] = useState(false);
    const [error, setError] = useState(null);
    
    const [data, setData] = useState([]);
    const [nextPage, setNextPage] = useState(null);
    const [prevPage, setPrevPage] = useState(null);
    const [currentPage, setCurrentPage] = useState(1);
    const [count, setCount] = useState(0);


    const fetchData = async (page = 1, tabType = activeTab) => {

  
      setloadingInvitation(true)
      setError(null)
  
  
      try {
  
     
        let typeurl;
        if(tabType === "agency")typeurl="/super-agency/"
        else if (tabType === "vendor")typeurl="/super-supplier/"
        else return
  
        const response = await api.get(typeurl + `?page=${page}`); // No need to wrap `data` in an object

            setData(response.data.results)
            setNextPage(response.data.next);
            setPrevPage(response.data.previous);
            setCount(response.data.count);
     
  
        
  
      } catch (error) {
        //console.error("Error submitting form:", error);
        console.log( error);
        // Extract response code if available
        const responseCode = error.response.data.detail ? error.response.data.detail : "Unknown";
        
        setError(responseCode)
        console.log("Response Code:", responseCode);
  
  
      } finally {
  
  
        setloadingInvitation(false);
      }
    }

    const handlePageChange = (page) => {
        if (page < 1 || page > Math.ceil(count / 10)) return; // Prevent invalid page numbers
        setCurrentPage(page);
        fetchData(page);
    };

    // Add tab change handler
    const handleTabChange = (tab) => {
        setActiveTab(tab);
        setCurrentPage(1);
        fetchData(1, tab);
    };





    const [menu, setMenu] = useState(false);
    const [show, setShow] = useState(false);

    const toggleMobileMenu = () => {
        setMenu(!menu);
    };

    //const datasource = Data?.Data;


    const columns = useMemo(() => [
       
        {
            title: activeTab === "vendor" ? "Vendor":"Agency",
            dataIndex: "name",
render: (value,record) => (

        <h2 className="table-avatar">
          <Link to="#" className="avatar-biodata me-2">
          {record.imgprofile ? (
            <img
              className="avatar-img rounded"
              src={record.imgprofile}
       
              alt="User"
            />
          ) : (
            
            <div style={{width:"100px",height:"100px",alignContent: "center",textAlign:"center"}}>
              <i className="fas fa-briefcase text-muted" style={{ fontSize: "50px" }}></i>
            </div>
          )}
          </Link>
          <Link to="#">
            {record.name} <span>

             {record.code}
               </span>

              { activeTab === "agency" && <div style={{color:"black"}}>

                     <p className="text-truncate" title={record.registration_number}><strong>Registration Number	 :</strong> {record.registration_number	}</p>
        <p className="text-truncate" title={record.employment_registration}><strong>Employment Registration	 :</strong> {record.employment_registration	}</p>


      </div>}
          </Link>
        </h2>

      ),
            sorter:false,
        },
  {
            title: "Info Admin",
            dataIndex: "admin_email",
            render: (value,record) => {
          
const adminUser = activeTab === "agency"?record.agency_users.find(user => user.is_admin_agency === true):record.supplier_users.find(user => user.is_admin_supplier === true)
const adminName = adminUser ? adminUser.name : "";
                return (
                 <div style={{color:"black"}}>

                     <p className="text-truncate" title={adminName}><strong>Name :</strong> {adminName}</p>
        <p className="text-truncate" title={record.phone}><strong>Contact Phone :</strong> {record.phone}</p>

        <p className="text-truncate" title={value}><strong>Admin Email:</strong> {value}</p>
      </div>
            )},
        },{
            title: "Relations Agency/Vendor",
            dataIndex: "agency_related_supplier",
            render: (value,record) => {
                 return (
                    value && value.length > 0 ? (
                        <div style={{ display: "flex", flexWrap: "wrap", maxWidth: "250px" ,gap:"5px"}}>
                            {value.map((company, index) => (
                               <span key={index} title={company.name} className={`m-1 badge badge-pill ${company.status ? 'bg-info' : 'bg-warning text-black'} text-truncate`} style={{padding: "7px 20px"}}>
                                {company.name}
                                </span>
                            ))}
                        </div>
                    ) : <span className="badge badge-pill bg-secondary "style={{padding: "7px 20px"}}>No Relations</span>
                )
            }
        },
      ...(activeTab === 'vendor' ? [
        {
            title: "Shared Biodata with Agency",
            dataIndex: "agency_name_and_biodata_count",
            render: (value, record) => {
                
                return (
                    value && value.length > 0 ? (
                        <div style={{ display: "flex", flexWrap: "wrap", maxWidth: "250px" }}>
                            {value.map((agency, index) => (
                                <Link key={index} to={`/vendor-agency-biodata?agency_id=${agency.agency_id}&vendor_id=${agency.supplier_id}&agency_name=${agency.agency_name}&vendor_name=${record.name}`}>
                                    <span title={`(${agency.biodata_count}) ${agency.agency_name}`} className="m-1 badge badge-pill bg-info text-truncate" style={{padding: "7px 20px"}}>({agency.biodata_count}) {agency.agency_name}</span>
                                </Link>
                            ))}
                        </div>
                    ) : <span className="badge badge-pill bg-secondary" style={{padding: "7px 20px"}}>No Biodata Shared</span>
                )
            }
        }

      ] : []),
        {
            title: "Verified",
            dataIndex: "verified",
            render: (value) => (
                <div>
                    {value ?  <span className="badge badge-pill bg-success-light">Verified</span> :
                   
                        <span className="badge badge-pill bg-warning text-black">Not Verified</span>}
                   
                </div>
            ),
            sorter: (a, b) => a.Status.length - b.Status.length,
        },
     {
    title: "Users",
    dataIndex: "users_count",
    render: (value, record) => {
        const company_users = activeTab === "agency" ? record.agency_users : record.supplier_users;
        
        return (
            <>
                <div><strong>Number of users:</strong> {value}</div>
                <div style={{ display: "flex", flexWrap: "wrap" ,maxWidth:"250px"}}>
                    {company_users.map((user, index) => (
                        <span title={user.name} key={index} className="m-1 badge badge-pill bg-info text-truncate" style={{padding: "7px 20px"}}>{user.name}</span>
                    ))}
                </div>
            </>
        );
    },
    sorter: (a, b) => a.users_count - b.users_count,
},
        {
            title: "Biodata",
            dataIndex: "biodata_count",
            sorter: (a, b) => a.biodata_count.length - b.biodata_count.length,
        },
        {
            title: "Created",
            dataIndex: "created_at",
            sorter: (a, b) => a.Created.length - b.Created.length,
        },
       
    ], [activeTab]); // Add activeTab as dependency

    const [screenWidth, setScreenWidth] = useState(window.innerWidth);
      
    const isMobileDevice = () => {
        const userAgent = navigator.userAgent || navigator.vendor || window.opera;
        return /android|webos|iphone|ipad|ipod|blackberry|iemobile|opera mini/i.test(userAgent);
    };

    useEffect(() => {
        const handleResize = () => {
            setScreenWidth(window.innerWidth);
        };

        // Add event listener for resizing
        window.addEventListener("resize", handleResize);

        // Cleanup event listener on component unmount
        return () => {
            window.removeEventListener("resize", handleResize);
        };
    }, []);


    return (
        <>
            <div className={`main-wrapper ${menu ? "slide-nav" : ""}`}>
                <Header onMenuClick={() => toggleMobileMenu()} />
                <Sidebar />

                <div className="page-wrapper">
                {
                (loadingInvitation || error) ? (
          <div style={{ textAlign: "center", margin: "10em" }}>
            {loadingInvitation && <i className="fa-solid fa-spinner fa-spin" style={{ fontSize: "4em" }} />}
            {error && (
              <div className="alert alert-danger alert-dismissible fade show" role="alert">
                <strong>Error!</strong> {error}
                {/*<button onClick={fetchData} className="btn btn-danger btn-sm ms-3">
                  Try Again
                </button>*/}
              </div>
            )}
          </div>
        ) : (
             <> 
            
                    <div className="content container-fluid">
                        
                        {/* Page Header */}
                        <div className="page-header">
                            <div className="content-page-header ">
                                <h5>Super Users</h5>
                                
                                {/* Add Tab Navigation */}
                                <div className="tab-navigation">
                                    <ul className="nav nav-tabs" role="tablist">
                                        <li className="nav-item" role="presentation">
                                            <button
                                                className={`nav-link ${activeTab === "vendor" ? "active" : ""}`}
                                                onClick={() => handleTabChange("vendor")}
                                                type="button"
                                                role="tab"
                                            >
                                                <Icon.Users className="me-2" size={16} />
                                                {t("Vendor")}
                                            </button>
                                        </li>
                                        <li className="nav-item" role="presentation">
                                            <button
                                                className={`nav-link ${activeTab === "agency" ? "active" : ""}`}
                                                onClick={() => handleTabChange("agency")}
                                                type="button"
                                                role="tab"
                                            >
                                                <Icon.Users className="me-2" size={16} />
                                                {t("Agency")}
                                            </button>
                                        </li>
                                    </ul>
                                </div>

                                <div className="list-btn">
                                    <ul className="filter-list">
                      

                                     
                                    </ul>
                                </div>
                            </div>
                        </div>
                        {/* /Page Header */}
         
                        <div className="row">
                            <div className="col-sm-12">
                                {isMobileDevice() || screenWidth <= 576 ? (
                                    <>
                                        <SuperUsersMobile handlePageChange={handlePageChange} currentPage={currentPage} nextPage={nextPage} prevPage={prevPage} count={count} activeTab={activeTab} data={data} user={user}/>
                                    </>
                                ) : (
                                    <div className="card">
                                        <div className="card-body">
                                            <div className="table-responsive table-hover">
                                                <Table
                                                    className="table"
                                                    pagination={{
                                                        total: count,
                                                        current: currentPage,
                                                        showTotal: (total, range) =>
                                                            `Showing ${range[0]} to ${range[1]} of ${total} entries`,
                                                        // showSizeChanger: true,
                                                        onShowSizeChange: onShowSizeChange,
                                                        itemRender:  (page, type, originalElement) => itemRender(t, handlePageChange, currentPage, prevPage, nextPage, page, type, originalElement),
                                                    }}
                                                    columns={columns}
                                                    dataSource={data}
                                                    rowKey={(record) => record.id}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                )}
                            </div>
                        </div>
                       
                               
                    </div>
                    </>)
}
                </div>

             

          
   
            </div>
        </>
    );
};

export default SuperUsers;
